import { useState } from "react";
import "./Footer.scss";
import Logo from "../assets/LOGO_FOOTER.png";
import { Link } from "react-router-dom";
import { Form, FormGroup, Image } from "react-bootstrap";
import { Envelope, Facebook, Instagram, ArrowUp } from "react-bootstrap-icons";
import dataWeb from "../assets/images/dataweb.jpg";
import useValidation from "../services/useValidation";
import { addToNewletter } from "../services/NewsletterServices";
import { usePage } from "../services/PageContext";

export default function Footer() {
  const [validated, setValidated] = useState(false);
  const emailValidation = useValidation('','email');
  const [emailAdded, setEmailAdded] = useState(false);
  const { siderMenu } = usePage()

  const handleSubmit = (event) => {
    const form = event.currentTarget
    event.preventDefault()
    event.stopPropagation()
    if (form.checkValidity()) {
      addToNewsletter();
    }
    setValidated(true)
  }

  const addToNewsletter = () => {
    var f = new FormData();
    f.append("email", emailValidation.value);
    addToNewletter(f)
    .then(()=>{
      setEmailAdded(true)
    })
    .catch(err=>{console.log(err)})
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <>
      <footer className={siderMenu ? 'is-mobile' : ''}>
        <div className="footer-wrapper">
          <div className="content">
            <div className="footer-top">
              <div className="footer-brand">
                <Link className="logo">
                  <Image src={Logo} />
                </Link>
                <div className="icons-content">
                  <a
                    className="icon"
                    href="https://www.facebook.com/libreriadelcolegio"
                    target="_blank"
                  >
                    <Facebook />
                  </a>
                  <a
                    className="icon"
                    href="https://instagram.com/libdelcolegio"
                    target="_blank"
                  >
                    <Instagram />
                  </a>
                </div>
              </div>
              <button type="button" className="scroll-top" onClick={scrollToTop} aria-label="Volver arriba">
                <ArrowUp />
              </button>
            </div>
            <hr />
            <div className="footer-content">
              <div className="module module-footer-desc">
                <h6>
                  Somos una distribuidora mayorista de libros, juegos y
                  juguetes. Estamos ubicados en Bahía Blanca, provincia de
                  Buenos Aires.
                </h6>
                <div className="newsletter-wrapper">
                  <div className="newsletter-header">
                    <span className="icon">
                      <Envelope />
                    </span>
                    <h4>
                      Informate de nuestras últimas noticias y ofertas
                      especiales
                    </h4>
                  </div>
                  <div className="newsletter-form-wrapper">
                    {!emailAdded
                      ? <Form noValidate validated={validated} onSubmit={handleSubmit}  className="newsletter-form">
                          <FormGroup>
                            <Form.Control
                              type="email"
                              value={emailValidation.value}
                              onChange={emailValidation.handleChange}
                              isInvalid={!emailValidation.isValid}
                              required
                            />
                            <Form.Control.Feedback type="invalid">
                              {emailValidation.errorMessage != '' ? emailValidation.errorMessage : "Debe ingresar el e-mail"}
                            </Form.Control.Feedback>
                          </FormGroup>

                            <button type="submit">Suscribirse</button>
                        </Form>
                      : <h3>Gracias</h3>
                    }
                  </div>
                </div>
              </div>
              <div className="module module-footer">
                <h3>Menú</h3>
                <Link to={'/como-operar'}>Cómo operar</Link>
                <Link to={'/faqs'}>Preguntas Frecuentes</Link>
                <Link to={'/cbu'}>Datos bancarios</Link>
                <Link to={'/registro'}>Registrate</Link>
                <Link to={'/terminos-condiciones'}> Términos y Condiciones</Link>
              </div>
              <div className="module module-footer module-footer-contact">
                <div className="contact-block">
                  <span className="label">WhatsApp</span>
                  <a href="https://wa.me/542915765101" target="_blank">
                    +54 291 576 5101
                  </a>
                </div>
                <div className="contact-block">
                  <span className="label">E-mail</span>
                  <a href="mailto:contacto@libreriadelcolegio.com">
                    contacto@libreriadelcolegio.com
                  </a>
                </div>
              </div>
              <div className="module module-footer module-footer-location">
                <div className="contact-block">
                  <span className="label">Dirección</span>
                  <p>
                    Zapiola 400, Bahía Blanca<br />
                    Buenos Aires, Argentina.
                  </p>
                </div>
                <div className="contact-block">
                  <span className="label">Horario de atención</span>
                  <p>Lun a Vie de 9 a 18 hs.</p>
                </div>
              </div>
            </div>

            <div className="copyright">
              <p>Todos los derechos reservados ®. 1982-2025</p>
              <p>
                <a
                  href="http://qr.afip.gob.ar/?qr=aNjSu-6x_oJPssWeerj_Eg,,"
                  target="_F960AFIPInfo"
                >
                  <Image src={dataWeb} />
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
